import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';

const BUSINESS_INFO = {
  whatsapp: '+919876543210',
  email: 'mail@drycleanspace.com',
  phone: '+91 98765 43210',
  address: 'Rohini Sector 11, New Delhi',
  instagram: 'https://instagram.com/drycleanspace',
  facebook: 'https://facebook.com/drycleanspace',
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-[#1A1A1A] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="font-heading text-3xl font-semibold tracking-tight">
              Dryclean<span className="text-[#C5A059]">space</span>
            </Link>
            <p className="mt-6 text-white/60 font-body text-sm leading-relaxed">
              Premium cleaning and restoration services for your luxury shoes and handbags.
              Restore luxury. Preserve style.
            </p>
            <div className="flex gap-4 mt-6">
              <a
                href={BUSINESS_INFO.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 border border-white/20 flex items-center justify-center transition-all hover:border-[#C5A059] hover:text-[#C5A059]"
              >
                <Instagram size={18} />
              </a>
              <a
                href={BUSINESS_INFO.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="w-10 h-10 border border-white/20 flex items-center justify-center transition-all hover:border-[#C5A059] hover:text-[#C5A059]"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-[#C5A059] mb-6">
              Quick Links
            </h4>
            <ul className="space-y-4">
              {['Home', 'Services', 'Gallery', 'About', 'Contact'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                    data-testid={`footer-link-${item.toLowerCase()}`}
                    className="text-white/60 text-sm hover:text-[#C5A059] transition-colors underline-animate"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-[#C5A059] mb-6">
              Services
            </h4>
            <ul className="space-y-4">
              {['Shoe Cleaning', 'Shoe Repair', 'Sneaker Restoration', 'Handbag Cleaning'].map((item) => (
                <li key={item}>
                  <Link
                    to="/services"
                    className="text-white/60 text-sm hover:text-[#C5A059] transition-colors underline-animate"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-[#C5A059] mb-6">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`mailto:${BUSINESS_INFO.email}`}
                  data-testid="footer-email"
                  className="flex items-start gap-3 text-white/60 text-sm hover:text-[#C5A059] transition-colors"
                >
                  <Mail size={18} className="mt-0.5 flex-shrink-0" />
                  {BUSINESS_INFO.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${BUSINESS_INFO.phone.replace(/\s/g, '')}`}
                  data-testid="footer-phone"
                  className="flex items-start gap-3 text-white/60 text-sm hover:text-[#C5A059] transition-colors"
                >
                  <Phone size={18} className="mt-0.5 flex-shrink-0" />
                  {BUSINESS_INFO.phone}
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/60 text-sm">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                {BUSINESS_INFO.address}
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-xs">
            &copy; {currentYear} Drycleanspace by Preet Kapoor. All rights reserved.
          </p>
          <p className="text-white/40 text-xs">
            Premium Care for Luxury Items
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
